import { useState, useEffect } from "react";
import styled from "styled-components";
import axios from "axios";

import PersonalInformation from "./Forms/PersonalInformation";
import ContactInformation from "./Forms/ContactInformation";
import EducationInformation from "./Forms/EducationInformation";
import SkillInformation from "./Forms/SkillInformation";
import InterestInformation from "./Forms/InterestInformation";
import Profile from "./Profile";
import SpecialityInformation from "./Forms/SpecialityInformation";

import "./EditProfile.scss";

const ProfileWrapper = styled.div`
  padding: 30px 0;
`;

const baseUrl = process.env.REACT_APP_EP_URL;

const EditProfile = (props) => {
  const {
    refreshUserProfileData,
    userProfileData,
    setIsEditProfile,
    isEditProfile,
    user,
    setIsRefreshData,
  } = props;

  const headers = {
    Authorization: "Bearer " + user.accessToken,
  };

  const [data, setData] = useState({});
  const [currentStep, setCurrentStep] = useState(1);
  const [skills, setSkills] = useState([]);
  const [interests, setInterests] = useState([]);

  const getSkills = async () => {
    try {
      const { slug } = user;
      const { data: responseData } = await axios.get(
        `${baseUrl}/api/profile/get-skills${slug}`,
        {
          headers,
        }
      );
      if (responseData?.data?.length) {
        setSkills(responseData.data);
      } else {
        setSkills([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getInterests = async () => {
    try {
      const { slug } = user;
      const { data: responseData } = await axios.get(
        `${baseUrl}/api/profile/get-interests${slug}`,
        {
          headers,
        }
      );
      if (responseData?.data?.length) {
        setInterests(responseData.data);
      } else {
        setInterests([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getSkills();
    getInterests();
  }, [user]);

  const getCurrentStepForm = (step) => {
    const role = user.role?.toLowerCase();
    const isTutor = user?.isTutor || false;
    const getTotalSteps = (role) => {
      switch (role) {
        case "student":
          return isTutor ? 7 : 6;
        case "teacher":
          return isTutor ? 7 : 5;
        case "admin":
          return isTutor ? 4 : 3;
        case "superadmin":
          return isTutor ? 7 : 3;
        case "externaltutor":
          return 7;
        case "parent":
          return isTutor ? 7 : 2;
        default:
          return 6;
      }
    };

    const values = {
      data,
      setData,
      currentStep,
      setCurrentStep,
      totalStep: getTotalSteps(role),
      setIsEditProfile,
      isEditProfile,
      user,
      skills,
      interests,
      setIsRefreshData,
      refreshUserProfileData,
    };

    switch (role) {
      case "student":
        switch (step) {
          case 1:
            return <PersonalInformation {...values} />;
          case 2:
            return <ContactInformation {...values} />;
          case 3:
            return (
              <EducationInformation {...values} role={role} isTutor={isTutor} />
            );
          case 4:
            return <SkillInformation {...values} />;
          case 5:
            return <InterestInformation {...values} />;
          case 6:
            return isTutor ? (
              <SpecialityInformation {...values} />
            ) : (
              <Profile {...values} />
            );
          case 7:
            return isTutor ? (
              <Profile {...values} />
            ) : (
              <PersonalInformation {...values} />
            );
          default:
            return <PersonalInformation {...values} />;
        }
      case "teacher":
        switch (step) {
          case 1:
            return <PersonalInformation {...values} />;
          case 2:
            return <ContactInformation {...values} />;
          case 3:
            return <SkillInformation {...values} />;
          case 4:
            return <InterestInformation {...values} />;
          case 5:
            return isTutor ? (
              <EducationInformation {...values} role={role} isTutor={isTutor} />
            ) : (
              <Profile {...values} />
            );
          case 6:
            return isTutor ? (
              <SpecialityInformation {...values} />
            ) : (
              <PersonalInformation {...values} />
            );
          case 7:
            return isTutor ? (
              <Profile {...values} />
            ) : (
              <PersonalInformation {...values} />
            );
          default:
            return <PersonalInformation {...values} />;
        }
      case "admin":
        switch (step) {
          case 1:
            return <PersonalInformation {...values} />;
          case 2:
            return <ContactInformation {...values} />;
          case 3:
            return isTutor ? (
              <EducationInformation {...values} role={role} isTutor={isTutor} />
            ) : (
              <Profile {...values} />
            );
          case 4:
            return isTutor ? (
              <Profile {...values} />
            ) : (
              <PersonalInformation {...values} />
            );
          default:
            return <PersonalInformation {...values} />;
        }
      case "superadmin":
        switch (step) {
          case 1:
            return <PersonalInformation {...values} />;
          case 2:
            return <ContactInformation {...values} />;
          case 3:
            return <SkillInformation {...values} />;
          case 4:
            return <InterestInformation {...values} />;
          case 5:
            return isTutor ? (
              <EducationInformation {...values} role={role} isTutor={isTutor} />
            ) : (
              <Profile {...values} />
            );
          case 6:
            return isTutor ? (
              <SpecialityInformation {...values} />
            ) : (
              <PersonalInformation {...values} />
            );
          case 7:
            return isTutor ? (
              <Profile {...values} />
            ) : (
              <PersonalInformation {...values} />
            );
          default:
            return <PersonalInformation {...values} />;
        }
      case "externaltutor":
        switch (step) {
          case 1:
            return <PersonalInformation {...values} />;
          case 2:
            return <ContactInformation {...values} />;
          case 3:
            return (
              <EducationInformation {...values} role={role} isTutor={true} />
            );
          case 4:
            return <SkillInformation {...values} />;
          case 5:
            return <InterestInformation {...values} />;
          case 6:
            return <SpecialityInformation {...values} />;
          case 7:
            return <Profile {...values} />;
          default:
            return <PersonalInformation {...values} />;
        }
      case "parent":
        if (!isTutor) {
          switch (step) {
            case 1:
              return <PersonalInformation {...values} />;
            case 2:
              return <ContactInformation {...values} />;
            default:
              return <PersonalInformation {...values} />;
          }
        } else {
          switch (step) {
            case 1:
              return <PersonalInformation {...values} />;
            case 2:
              return <ContactInformation {...values} />;
            case 3:
              return (
                <EducationInformation {...values} role={role} isTutor={true} />
              );
            case 4:
              return <SkillInformation {...values} />;
            case 5:
              return <InterestInformation {...values} />;
            case 6:
              return <SpecialityInformation {...values} />;
            case 7:
              return <Profile {...values} />;
            default:
              return <PersonalInformation {...values} />;
          }
        }
    }
  };

  useEffect(() => {
    setData(userProfileData);
  }, [userProfileData]);

  return (
    <ProfileWrapper className="edit-profile-wrapper">
      {getCurrentStepForm(currentStep)}
    </ProfileWrapper>
  );
};

export default EditProfile;
